/**
 * Device type detection
 * @note This need to work with is_JS library
 */
var _html = document.querySelector('html');
var _class = [];
if (is.desktop()) _class.push('is-desktop');
if (is.mobile()) _class.push('is-mobile');
if (is.tablet()) _class.push('is-tablet');
if (is.ie()) _class.push('is-ie');
if (is.edge()) _class.push('is-edge');
if (is.safari()) _class.push('is-safari');
_class.forEach(className => {
	_html.classList.add(className);
});